export function parseMonthYear(dateStr: string | null | undefined): { month: number | null; year: number | null } {
  if (!dateStr) return { month: null, year: null };
  const parsed = new Date(dateStr);
  if (isNaN(parsed.getTime())) return { month: null, year: null };
  return { month: parsed.getMonth() + 1, year: parsed.getFullYear() };
}

export function buildISODate(month: number, year: number): string {
  return `${year}-${String(month).padStart(2, "0")}-01`;
}

export function monthYearKey(dateStr: string | null | undefined): string {
  const { month, year } = parseMonthYear(dateStr);
  if (month == null || year == null) return "";
  return `${year}-${String(month).padStart(2, "0")}`;
}
